import type { FilterDefinition } from "@/components/filters/FilterBar";
import { CustomFieldFilterContent } from "@/components/filters/CustomFieldFilterContent";
import { idSelectionSummary } from "@/components/filters/idSelectionSummary";
import {
  customFieldId,
  isUserCustomField,
  type FilterableCustomField,
} from "@/lib/customFieldFilters";
import { CUSTOM_FIELD_TYPE_ICONS } from "@/lib/customFieldTypes";

/**
 * Builds the filter bar chip for one custom field: its key, label, type icon,
 * selection summary, and multi-select dropdown.
 */
export function customFieldFilterDefinition({
  field,
  selected,
  userName,
  onChange,
}: {
  field: FilterableCustomField;
  selected: string[];
  userName: (id: string) => string | null;
  onChange: (next: string[]) => void;
}): FilterDefinition {
  return {
    key: customFieldId(field.name),
    label: field.name,
    icon: CUSTOM_FIELD_TYPE_ICONS[field.type],
    summary: idSelectionSummary(
      selected,
      isUserCustomField(field) ? userName : (id) => id,
    ),
    content: (
      <CustomFieldFilterContent
        field={field}
        selected={selected}
        onChange={onChange}
      />
    ),
  };
}
